import React from 'react';
import type { AnyMessage } from '../chatTypes';
import { isTextMessage } from '../chatTypes';
import ChatTextMessage from './ChatTextMessage';

import type { ChatOptions } from './ChatMessageComponentsTypes';

export type ChatMessageComponentProps = {
  message: AnyMessage;
} & Omit<ChatOptions, 'showDateDivider'>;

export default function ChatMessageComponent({
  message,
  headerOptions
}: ChatMessageComponentProps): JSX.Element {
  if (isTextMessage(message)) {
    return (
      <ChatTextMessage
        person={message.user}
        date={message.date}
        text={message.content.text}
        headerOptions={headerOptions}
        errorText={message.error}
      />
    );
  }

  // should never happen
  return <>Unknown message type</>;
}
